// body-page-type-class.directive.ts
import { DOCUMENT } from '@angular/common';
import { Directive, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../services/layout/layout.service';

@Directive({
    selector: '[appBodyPageTypeClass]',
    standalone: true,
})
export class BodyPageTypeClassDirective implements OnInit, OnDestroy {
    private sub?: Subscription;
    private lastPageTypeClass?: string;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private layoutSvc: LayoutService
    ) {}

    ngOnInit(): void {
        this.sub = this.layoutSvc.pageType$.subscribe(
            (pageType: string | null) => {
                const body = this.document.body;

                // quitamos la clase anterior si existía
                if (this.lastPageTypeClass) {
                    this.renderer.removeClass(body, this.lastPageTypeClass);
                }

                if (pageType) {
                    const cssClass = `page-type-${pageType}`
                        .trim()
                        .toLowerCase()
                        .replace(/\s+/g, '-') // espacios -> guiones
                        .replace(/[^a-z0-9\-]/g, ''); // quita raros

                    this.renderer.addClass(body, cssClass);
                    this.lastPageTypeClass = cssClass;
                } else {
                    this.lastPageTypeClass = undefined;
                }
            }
        );
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();

        // limpieza por si queda la clase puesta
        if (this.lastPageTypeClass) {
            this.renderer.removeClass(
                this.document.body,
                this.lastPageTypeClass
            );
        }
    }
}
